import type { ValueFormatterParams } from 'ag-grid-community';
import { gridLocale } from '@h20-shared/grids/grid-context';
import { numberFormatter } from '@h20-shared/utils/number-format-utils';

const EMPTY_CELL_TEXT = '';
const COUNT_FORMAT: Intl.NumberFormatOptions = { maximumFractionDigits: 0 };

type CountFormatterParams = Pick<
    ValueFormatterParams<unknown, number, unknown>,
    'value' | 'context'
>;

export function formatPatientCount(params: CountFormatterParams): string {
    if (typeof params.value !== 'number') {
        return EMPTY_CELL_TEXT;
    }
    return numberFormatter(gridLocale(params.context), COUNT_FORMAT).format(params.value);
}
